/**
 * The document title Inertia writes on each visit: the page's title and the
 * site's name, joined by " | " exactly as the server's <title> joins them
 * (resources/views/app.blade.php), from the same name (config synex.site_name,
 * handed to the page as window.__SYNEX_SITE_NAME__; never APP_NAME, which
 * names the environment), so the tab keeps its brand and separator when
 * Inertia takes the server's <title> over. A page that sets no title gets
 * the site's name alone.
 */
export const TITLE_SEPARATOR = ' | ';

/** config/synex.php's default site name, for a page served without one. */
export const SITE_NAME = 'Synex Cloud';

export default function pageTitle(title, siteName = (typeof window !== 'undefined' && window.__SYNEX_SITE_NAME__) || SITE_NAME) {
    return title ? `${title}${TITLE_SEPARATOR}${siteName}` : siteName;
}
